export const TIMEOUT = 60 * 1000;
export const RETRY_DELAY = 3000;
export const COMPANY_NAME_SECTION_TITLE = 'Company name';
export const ATTACHMENTS_SECTION_TITLE = 'Attachments';
